import { HTMLProps, useEffect, useRef } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import { IconColor, IconSize, Icons } from '../../../enums';
import Icon from '../../Icon';

const Container = styled.div`
  ${tw`relative align-middle  w-5`};
`;

const HiddenInput = styled.input`
  ${tw`absolute w-full h-full top-0 opacity-0 cursor-pointer`};
`;

const StyledInput = styled.div<{ $isChecked: boolean }>`
  ${tw`cursor-pointer relative flex items-center justify-center shrink-0 appearance-none w-5 h-5 border border-slate-400 rounded-lg bg-gradient-to-b from-white to-slate-100`};

  ${({ $isChecked }) =>
    $isChecked && tw`bg-primary from-emerald-600 to-primary border-0`};

  &:after {
    ${tw`absolute text-white drop-shadow transition opacity-0 translate-y-1.5`};

    ${({ $isChecked }) => $isChecked && tw`opacity-100 translate-y-0`};
  }
`;

function IndeterminateCheckbox({
  indeterminate,
  className,
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
  const ref = useRef<HTMLInputElement>(null!);

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  useEffect(() => {
    // Override focus behavior to prevent Chrome from scrolling to the checkbox
    if (ref.current) {
      const element = ref.current;
      const originalFocus = element.focus.bind(element);
      element.focus = (options?: FocusOptions) => {
        originalFocus({ ...options, preventScroll: true });
      };
    }
  }, []);

  return (
    <Container>
      <StyledInput $isChecked={rest.checked || false}>
        {rest.checked && (
          <Icon
            icon={Icons.check}
            color={IconColor.white}
            size={IconSize.extraSmall}
          />
        )}
      </StyledInput>
      <HiddenInput type="checkbox" ref={ref} className={className} {...rest} />
    </Container>
  );
}

export default IndeterminateCheckbox;
